import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { ActoCondicionModel } from 'src/app/models/acto-condicion/ActoCondicionModel';
import { FilterActoCondicionModel } from 'src/app/models/acto-condicion/FilterActoCondicionModel';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IActoCondicionModel } from 'src/app/models/interfaces/acto-condicion/IActoCondicionModel';
import { IFilterActoCondicionModel } from 'src/app/models/interfaces/acto-condicion/IFilterActoCondicionModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { ActoCondicionService } from 'src/app/services/acto-condicion/acto-condicion.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';

@Component({
  templateUrl: './configuracion-acto-condicion-listar.component.html',
  styleUrls: ['./configuracion-acto-condicion-listar.component.css']
})
export class ConfiguracionActoCondicionListarComponent implements OnInit {
  model!: SearchResultModel<IActoCondicionModel[]>;
  filter: IFilterActoCondicionModel = new FilterActoCondicionModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();
  resultsLength = 0;
  currentPage = 0;

  displayedColumns: string[] = [
    'id',
    'nombre',
    'estado',
    'acciones'
  ];
  
  @ViewChild('paginator') paginator!: MatPaginator;

  constructor(
    private serviceActoCondicion: ActoCondicionService,
    private serviceParametros: ParametroService
  ) { 
    this.model = new SearchResultModel<IActoCondicionModel[]>(false, new Array<ActoCondicionModel>(), 0, 1, 0);
  }

  ngOnInit(): void {
    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_MAESTRO).subscribe((data) => {
      this.listaEstados = data.items;
    });
    
    this.serviceActoCondicion.getListFiltered(this.filter).subscribe((data) => {
      this.model = data;
      this.resultsLength = data.total;
    });
  }

  search(): void{
    this.filter.page = 1;
    this.filter.pageSize = 30;
    this.serviceActoCondicion
      .getListFiltered(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  getPaginatorData(event: any) {
    this.filter.page = event.pageIndex + 1;
    this.filter.pageSize = event.pageSize;
    this.serviceActoCondicion
      .getListFiltered(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
      });
  }

}
